import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

function EditDish() {
  const { id } = useParams(); 
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetchDish();
  }, []);

  const fetchDish = async () => {
    try {
      const res = await axios.get(`https://api.kafkaorostkaffee.com/dishes/${id}`);
      setTitle(res.data.title);
      setPrice(res.data.price);
      setCategory(res.data.category);
      setDescription(res.data.description);
      setImageUrl(res.data.image_url);
    } catch (err) {
      console.error("Error fetching dish:", err);
    }
  };

  // رفع الصورة على السيرفر
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      setUploading(true);
      const res = await axios.post("https://api.kafkaorostkaffee.com/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setImageUrl(res.data.imageUrl);
    } catch (err) {
      console.error("Error uploading image:", err);
      alert("Failed to upload image!");
    } finally {
      setUploading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://api.kafkaorostkaffee.com/dishes/${id}`, {
        title,
        price,
        category,
        description,
        image_url: imageUrl,
      });
      alert("Dish updated ✅");
      navigate("/admin"); 
    } catch (err) {
      console.error("Error updating dish:", err);
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: "50px auto" }}>
      <h2>Edit Dish</h2>
      <form onSubmit={handleUpdate}>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        <input
          type="number"
          placeholder="Price"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        >
          <option value="">Select Category</option>
          <option value="breakfast">Breakfast</option>
          <option value="hotdrinks">Hot Drinks</option>
          <option value="colddrinks">Cold Drinks</option>
          <option value="lunch">Lunch</option>
          <option value="dinner">Dinner</option>
          <option value="shakes">Shakes</option>
        </select>
        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ width: "100%", marginBottom: 10, padding: 8 }}
        />
        {/* رفع الصورة */}
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        {uploading && <p>Uploading image...</p>}
        {imageUrl && (
          <div>
            <img src={imageUrl} alt="preview" width="150" />
          </div>
        )}

        <button type="submit" style={{ width: "100%", padding: 10 }} disabled={uploading}>
          {uploading ? "Uploading..." : "Update Dish"}
        </button>
      </form>
    </div>
  );
}

export default EditDish;
